const log = (logLevel, message) => {
  if (typeof window !== 'undefined' && window.FS && window.FS.log) {
    window.FS.log(logLevel, message);
  }
};

export default {
  log: message => log('log', message),
  logInfo: message => log('info', message),
  logWarning: message => log('warning', message),
  logError: message => log('error', message),
};
